// src/utils/crew.js
// Auto e piloti dell'allenamento: voci dei campi di scelta (PickField) e
// numero del dispositivo come lo legge il server (deviceRoster.js).
const API_BASE = process.env.REACT_APP_API_BASE || (window.location.protocol === 'https:' ? '' : `http://${window.location.hostname}:5000`);

// "14" → "14" · "58 ble" → "58" · "Kart A" → "KART A"
export const normDeviceId = (v) => {
  const s = String(v == null ? '' : v).trim();
  if (!s) return null;
  const d = s.match(/\d+/);
  return d ? String(parseInt(d[0], 10)) : s.toUpperCase();
};

export const carItem = (c) => ({
  id: String(c.id),
  label: c.number ? `${c.name} · #${String(c.number).replace(/^#/, '')}` : c.name,
  sub: [c.type, c.power].filter(Boolean).join(' · '),
  img: c.photoUrl ? `${API_BASE}${c.photoUrl}` : null,
});

export const pilotItem = (p) => ({
  id: String(p.id),
  label: `${p.name || ''} ${p.surname || ''}`.trim() || 'Pilota',
  sub: p.team || '',
  // senza foto: icona (non tutte le copie hanno l'immagine predefinita)
  img: p.photoDriverUrl && p.photoDriverUrl !== 'null' ? `${API_BASE}${p.photoDriverUrl}` : null,
});

// Turni di guida: nome del pilota (oggetto della sessione o testo del report)
export const stintPilotName = (s) => (typeof s?.pilot === 'string' ? s.pilot : s?.pilot?.name) || 'Pilota';

// Ora del giorno HH:MM (ora del browser)
export const fmtClock = (ms) => {
  if (ms == null || !Number.isFinite(Number(ms))) return '';
  try { return new Intl.DateTimeFormat('it-IT', { hour: '2-digit', minute: '2-digit' }).format(new Date(Number(ms))); } catch { return ''; }
};

// Durata in minuti, per i turni di guida
export const fmtMinutes = (from, to) => {
  if (!Number.isFinite(Number(from)) || !Number.isFinite(Number(to))) return '';
  const m = Math.max(0, Math.round((Number(to) - Number(from)) / 60000));
  return m < 60 ? `${m} min` : `${Math.floor(m / 60)} h ${String(m % 60).padStart(2, '0')}`;
};

// Tempo sul giro m:ss.mmm
export const fmtLapShort = (t) => {
  const v = Number(t);
  if (!Number.isFinite(v) || v <= 0) return '—';
  const m = Math.floor(v / 60), s = v - m * 60;
  return `${m}:${s.toFixed(3).padStart(6, '0')}`;
};

// Chiave di un pilota nei turni di guida (stessa per scheda e riepilogo)
export const stintPilotKey = (s) => String(s?.pilot?.id ?? s?.pilot?.name ?? `turno${s?.n}`);
